import { ComponentProps } from "react";
import { PulseLoader as SpinnersPulseLoader } from "react-spinners";

type PulseLoaderProps = ComponentProps<typeof SpinnersPulseLoader>;

/** Three-dot pulse in a row. Default react-spinners PulseLoader inherits
 *  parent flex-direction and stacks vertically in column layouts. */
export default function PulseLoader({
  cssOverride,
  ...props
}: PulseLoaderProps) {
  return (
    <SpinnersPulseLoader
      {...props}
      cssOverride={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "center",
        ...cssOverride,
      }}
    />
  );
}
